<template>
  <div class="filter-section">
    <div class="filter-header" @click="toggleFilters">
      <i :class="{'bi-chevron-down': !isCollapsed, 'bi-chevron-right': isCollapsed}"></i>
      Filtry
    </div>
    <div v-show="!isCollapsed" class="filter-content">
      <div class="form-check form-switch mb-2">
        <input class="form-check-input" type="checkbox" role="switch"
               id="showDeletedInvoices" v-model="localFilters.showDeletedInvoices" @change="emitFilters">
        <label class="form-check-label" for="showDeletedInvoices">Zobrazovat i smazané faktury</label>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref, watch, defineProps, defineEmits, onMounted} from 'vue'

const props = defineProps({
  collapsedDefault: {
    type: Boolean,
    default: true
  },
  modelValue: {
    type: Object,
    default: () => ({
      showDeletedInvoices: false
    })
  }
})

const emit = defineEmits(['update:modelValue'])

const isCollapsed = ref(true)
const localFilters = ref({...props.modelValue})

const toggleFilters = () => {
  isCollapsed.value = !isCollapsed.value
}

const emitFilters = () => {
  emit('update:modelValue', {...localFilters.value})
}

watch(() => props.modelValue, (newVal) => {
  localFilters.value = {...newVal}
}, {deep: true})

onMounted(() => {
  isCollapsed.value = props.collapsedDefault
})

</script>

<style scoped>
.filter-section {
  margin: 1rem 0;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
}

.filter-header {
  padding: 0.75rem;
  background-color: #f8f9fa;
  cursor: pointer;
  user-select: none;
}

.filter-header i {
  margin-right: 0.5rem;
}

.filter-content {
  padding: 1rem;
  border-top: 1px solid #dee2e6;
}

.form-check {
  padding-left: 2.5em;
}
</style>


